@if (!isLoading()) {
	<div
		#container
		class="sh-container"
		[innerHTML]="image()"
		[class.sh-identify]="isIdentifying() && !errorIndicator()"
		[class.sh-flashing]="isFlashing()"
		[class.sh-off]="disableLeds()"
	></div>
}
